module.exports = __webpack_public_path__ + "static/media/revenue-bg.70dc60d7.png";